import { Check } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { money } from "@/lib/format";

// Live price label for a membership tier, straight from the admin-configured plans.
export function useMembershipPriceLabel(key) {
  const { data: plans = [] } = useQuery({ queryKey: ["memberships"], queryFn: () => api.get("/memberships").then((r) => r.data), staleTime: 60000 });
  const p = plans.find((m) => m.key === key);
  if (!p) return "";
  if (!Number(p.price) || p.interval === "free") return "Free";
  return `${money(Number(p.price))}/${p.interval === "year" ? "yr" : "mo"}`;
}

const BENEFITS = {
  discovery: {
    label: "Discovery",
    items: [
      "Save your GAUGE Exploration results & track your journey",
      "Book wellness offerings at any center",
      "Stay connected to events, retreats & teachings",
      "Discover stewardship opportunities near you",
    ],
  },
  community: {
    label: "Community",
    items: [
      "Everything in Discovery, plus:",
      "Join social groups & spirals (Men's, Women's, Recovery…)",
      "Daily GAUGE coaching & personalized recommendations",
      "Post on the community timeline & private messaging",
      "Member pricing on courses & events",
    ],
  },
};

export function MembershipBenefits({ plan = "discovery", className = "" }) {
  const b = BENEFITS[plan] || BENEFITS.discovery;
  const price = useMembershipPriceLabel(BENEFITS[plan] ? plan : "discovery");
  return (
    <div data-testid="membership-benefits" className={`rounded-xl bg-[#144F75]/[0.04] border border-[#144F75]/10 p-4 ${className}`}>
      <p className="text-xs uppercase tracking-wider text-[#D98E73] font-semibold mb-2">Why join · {b.label}{price ? ` · ${price}` : ""}</p>
      <ul className="space-y-1.5">
        {b.items.map((it, i) => (
          <li key={i} className="flex gap-2 text-sm text-[#4A5D6B]">
            <Check size={15} className="text-[#144F75] shrink-0 mt-0.5" /> {it}
          </li>
        ))}
      </ul>
    </div>
  );
}
